import React from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SectionHeader, Button, Loading, EmptyState, Avatar, Tag } from "@/components/brand";
import dayjs from "dayjs";

export default function AdminUsers() {
  const qc = useQueryClient();
  const users = useQuery({ queryKey: ["admin", "users"], queryFn: () => api("/admin/users") });
  const toggle = useMutation({ mutationFn: (id) => api(`/admin/users/${id}/toggle`, { method: "POST" }), onSuccess: () => { qc.invalidateQueries({ queryKey: ["admin", "users"] }); toast.success("Updated"); }, onError: (e) => toast.error(e.message) });

  return (
    <div data-testid="admin-users-screen" className="space-y-5">
      <SectionHeader title="Users" subtitle="Manage member and trainer accounts." />
      {users.isLoading ? <Loading /> : (users.data ?? []).length === 0 ? <EmptyState title="No users" /> : (
        <div className="space-y-2">
          {users.data.map((u) => (
            <div key={u.id} data-testid={`admin-user-${u.id}`} className="flex items-center gap-3 p-3 rounded-xl2 border border-divider">
              <Avatar uri={u.avatar} size={44} name={u.name} />
              <div className="flex-1 min-w-0"><div className="font-display text-base text-ink truncate">{u.name}</div><div className="font-body text-xs text-mutedgrey truncate">{u.email} · joined {u.created_at ? dayjs(u.created_at).format("MMM YYYY") : "–"}</div></div>
              <Tag label={u.role} tone={u.role === "admin" ? "dark" : "pink"} />
              {u.disabled ? <Tag label="disabled" tone="grey" /> : null}
              {u.role !== "admin" ? <Button testID={`toggle-${u.id}`} title={u.disabled ? "Enable" : "Disable"} small variant={u.disabled ? "primary" : "outline"} loading={toggle.isPending} onClick={() => toggle.mutate(u.id)} /> : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
